(() => {
  const root = document.querySelector('[data-archive-artist]');
  if (!root) return;
  const purchased = root.hasAttribute("data-purchased-artist");
  const select = root.querySelector('select');
  const input = root.querySelector('[role="combobox"]');
  const panel = root.querySelector('.dac-archive-artist__panel');
  const list = root.querySelector('[role="listbox"]');
  const status = root.querySelector('[role="status"]');
  const clear = root.querySelector('[data-archive-artist-clear]');
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  let artists = [...select.options].map(option => ({ value: option.value, label: option.textContent, key: normalize(option.textContent) }));
  const exclusiveVendors=new Set();
  let ready = false;
  let loading;
  let shown = [];
  let active = -1;
  const close = () => {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  };
  const sync = () => {
    const value = purchased ? new URL(location.href).searchParams.get("artist") || "" : select.value;
    if (purchased) select.value = value;
    const selected = artists.find(artist => artist.value === value);
    input.value = value ? selected?.label || value.replace(/^By[\s\u00a0]+/, '') : '';
    clear.hidden = !value;
    status.textContent = '';
    close();
  };
  async function loadArtists() {
    input.setAttribute('aria-busy', 'true');
    try {
      let vendors;
      if (purchased) {
        vendors = new Set(await window.DACPurchasedArtists.load());
      } else {
      const url = new URL(root.dataset.indexUrl, location.origin);
      url.searchParams.set('view', 'dac-archive-artists');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      async function getPage(page) {
        const pageURL = new URL(url);
        pageURL.searchParams.set('page', page);
        const response = await fetch(pageURL, { signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Artist index unavailable');
        const data = await response.json();
        if (data.page !== page || !Number.isInteger(data.pages) || data.pages < 1 || !Array.isArray(data.vendors) || !data.vendors.every(value => typeof value === 'string')) throw new Error('Invalid artist index');
        return data;
      }
      const first = await getPage(1);
      vendors = new Set(first.vendors);
      let nextPage = 2;
      await Promise.all(Array.from({ length: Math.min(3, first.pages - 1) }, async () => {
        while (nextPage <= first.pages) {
          const data = await getPage(nextPage++);
          data.vendors.forEach(vendor => vendors.add(vendor));
        }
      }));
      }
      exclusiveVendors.forEach(vendor=>vendors.add(vendor));
      const all = artists[0];
      artists = [all, ...[...vendors].filter(Boolean).map(value => {
        const label = value.replace(/^By[\s\u00a0]+/, '');
        return { value, label, key: normalize(label) };
      }).sort((a, b) => a.label.localeCompare(b.label))];
      const selected = select.value;
      select.replaceChildren(...artists.map(artist => {
        const option = document.createElement('option');
        option.value = artist.value;
        option.textContent = artist.label;
        return option;
      }));
      select.value = artists.some(artist => artist.value === selected) ? selected : '';
      ready = true;
      root.dataset.indexReady = 'true';
      if (document.activeElement === input) render();
    } catch {
      loading = null;
      if (document.activeElement === input) status.textContent = root.dataset.unavailable;
    } finally {
      input.setAttribute('aria-busy', 'false');
    }
  }
  function render() {
    if (!ready && !loading) loading = loadArtists();
    const tokens = normalize(input.value).split(/\s+/).filter(Boolean);
    const matches = artists.filter(artist => tokens.every(token => artist.key.includes(token)));
    if (tokens.length) matches.sort((a, b) => Number(b.key.startsWith(tokens[0])) - Number(a.key.startsWith(tokens[0])));
    shown = matches.slice(0, 12);
    list.replaceChildren(...shown.map((artist, index) => {
      const item = document.createElement('li');
      item.id = `archive-artist-option-${index}`;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'false');
      item.dataset.index = index;
      item.textContent = artist.label;
      return item;
    }));
    root.querySelector('[data-archive-artist-empty]').hidden = shown.length > 0 || !ready;
    status.textContent = !ready ? root.dataset.loading : matches.length ? root.dataset.matches.replace('__count__', matches.length) : '';
    panel.hidden = !shown.length && !ready;
    input.setAttribute('aria-expanded', String(!panel.hidden));
    input.removeAttribute('aria-activedescendant');
    clear.hidden = !input.value && !select.value;
    active = -1;
  }
  function choose(artist, dismissKeyboard = true) {
    if (!artist) return;
    if (artist.value && root.dataset.enabled !== 'true') {
      close();
      status.textContent = root.dataset.unavailable;
      return;
    }
    select.value = artist.value;
    sync();
    if (dismissKeyboard) input.blur();
    if (purchased) window.DACPurchasedArtists.choose(artist.value);
    else document.dispatchEvent(new Event('dac:archive-artist-change'));
    if (purchased) sync();
  }
  input.addEventListener('input', render);
  input.addEventListener('focus', render);
  input.addEventListener('click', () => { if (panel.hidden) render(); });
  input.addEventListener('keydown', event => {
    if (event.isComposing) return;
    if (event.key === 'Escape') { event.preventDefault(); sync(); return; }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (panel.hidden) render();
      if (!shown.length) return;
      active = active < 0 ? (event.key === 'ArrowDown' ? 0 : shown.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + shown.length) % shown.length;
      [...list.children].forEach((item, index) => item.setAttribute('aria-selected', String(index === active)));
      const item = list.children[active];
      input.setAttribute('aria-activedescendant', item.id);
      item.scrollIntoView({ block: 'nearest' });
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      const exact = artists.find(artist => artist.key === normalize(input.value));
      choose(active >= 0 ? shown[active] : exact || (shown.length === 1 ? shown[0] : null));
    }
  });
  list.addEventListener('mousedown', event => event.preventDefault());
  list.addEventListener('click', event => {
    const item = event.target.closest('[data-index]');
    if (item) choose(shown[Number(item.dataset.index)]);
  });
  root.addEventListener('focusout', event => {
    if (!root.contains(event.relatedTarget)) sync();
  });
  document.addEventListener('pointerdown', event => {
    if (!root.contains(event.target)) sync();
  });
  clear.addEventListener('click', () => { choose(artists[0], false); input.focus(); sync(); });
  root.querySelector('form').addEventListener('submit', event => event.preventDefault());
  document.addEventListener(purchased ? 'dac:purchased-artist-sync' : 'dac:archive-artist-sync', sync);
  if (!purchased) document.addEventListener('dac:archive-exclusive-artists', event => {
    if (!Array.isArray(event.detail)) return;
    for (const value of event.detail) {
      if (typeof value !== 'string' || !value) continue;
      exclusiveVendors.add(value);
      if (artists.some(artist=>artist.value===value)) continue;
      const label=value.replace(/^By[\s\u00a0]+/, '');
      artists.push({value,label,key:normalize(label)});
      const option=document.createElement('option');option.value=value;option.textContent=label;select.append(option);
    }
    if (document.activeElement===input) render();
  });
  if (purchased) document.addEventListener('dac:purchased-artists-invalidated', () => { ready = false; loading = null; sync(); });
  root.querySelector('.dac-archive-artist__fallback').hidden = true;
  select.tabIndex = -1;
  root.querySelector('label').htmlFor = input.id;
  root.querySelector('.dac-archive-artist__enhanced').hidden = false;
  sync();
})();
